import { Component } from "react";
import "./ProjectSelectorStyle.css";

class ProjectSelector extends Component{
    
    handleClick = (index) => {
        this.props.tabChangeCallback(index);
    }

    capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }
    
    render(){

        var items = this.props.options;

        return <div>
            <div className="ProjectSelector">
                <img src="/assets/filter.png" className="filter"/>
                {items.map((item, index) => (
                    
                    index == this.props.selection ? 
                        <div key={item} className="Selected" onClick={()=>this.handleClick(index)}>
                            {this.capitalizeFirstLetter(item)}
                        </div> 
                        : 
                        <div key={item} className="NotSelected" onClick={()=>this.handleClick(index)}>
                            {this.capitalizeFirstLetter(item)}
                        </div>
                ))}
            </div>
        </div>
    }
}

export default function(props){
    return <ProjectSelector {...props} 
    selection={props.tabSelected} 
    tabChangeCallback={props.tabChangeCallback} 
    options={props.options}/>
}